import * as React from 'react'
import Box from '@mui/material/Box';
import Grid from '@mui/material/Unstable_Grid2';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { CabezeraRetencion } from '../../componentes/reporte/cabezera';
import { Moneda } from '../../constantes';

import moment from 'moment';
import logof from '../../imagenes/logofirma.png';

const Itemd = styled(Box)(({ theme }) => ({
    color:'#000', padding:1, border: '1px solid grey'
}));

export default function RetencionPDF(props) {
    const Tletra = 9;
    
    const {datos}= props;
    
    React.useEffect(()=>{
        const Iniciar = async()=>{
            // let nuevos = await genera_formulario({valores:{}, campos: Form_todos('Form_Mensualidades') });
            // nuevos.titulos.meses.noeliminar=true;
            // nuevos.titulos.meses.nopaginar=true;
            // nuevos.titulos.meses.label='';
            // nuevos.titulos.meses.style={
            //     height:'auto',
            //     borderColor:'#000',
            //     border:1,
            // }
            // nuevos.titulos.meses.titulos='Titulos_Mensualidad3';
            // setFormulario(nuevos);

            // let titulos = await Titulos_todos(nuevos.titulos.meses.titulos);
            
            // titulos[2].field='total';
            
            // setCabezera(titulos);
            
        }
        Iniciar();
    },[props])
    
    const color = '#000000';
    // const subtotal ='0,00';
    // const iva = valores 
    //             ? Number(Number(subtotal * 16/100)).toFixed(2)
    //             :'0,00';
    // const total = (Number(subtotal) + Number(iva)).toFixed(2) ;
    return (
        <Box sx={{ flexGrow: 1, bgcolor:'#fff', padding:2, 
                    ...props.sizePagina ? props.sizePagina : {width:612, height:700} 
                }}>
        <Grid container spacing={0}>
            <Grid xs={12}>
                    <Box sx={{height:0}}/>
            </Grid>
            <CabezeraRetencion {...props} />
            <Grid xs={9} container>
                <Grid xs={12}>
                    <Itemd component="div" >
                        <Typography color={color} 
                                align={'center'}
                                fontSize={Tletra-1} noWrap  
                                sx={{ fontWeight:'bold'}}        
                        >
                            FACTURA
                        </Typography>
                    </Itemd>
                </Grid>
                <Grid xs={1.3}>
                    <Itemd component="div" >
                        <Typography color={color} 
                                align={'center'}
                                fontSize={Tletra-1} noWrap  
                                sx={{ fontWeight:'bold'}}        
                        >
                            Fecha
                        </Typography>
                    </Itemd>
                </Grid>
                <Grid xs={1.5}>
                    <Itemd component="div" >
                        <Typography color={color} 
                                align={'center'}
                                fontSize={Tletra-1} noWrap  
                                sx={{ fontWeight:'bold'}}        
                        >
                            Número
                        </Typography>
                    </Itemd>
                </Grid>
                <Grid xs={1.8}>
                    <Itemd component="div" >
                        <Typography color={color} 
                                align={'center'}
                                fontSize={Tletra-1} noWrap  
                                sx={{ fontWeight:'bold'}}        
                        >
                            N° control
                        </Typography>
                    </Itemd>
                </Grid>
                <Grid xs={1.5}>
                    <Itemd component="div" >
                        <Typography color={color} 
                                align={'center'}
                                fontSize={Tletra-1} noWrap  
                                sx={{ fontWeight:'bold'}}        
                        >
                            Monto total
                        </Typography>
                    </Itemd>
                </Grid>
                <Grid xs={1.6}>
                    <Itemd component="div" >
                        <Typography color={color} 
                                align={'center'}
                                fontSize={Tletra-1} noWrap 
                                sx={{ fontWeight:'bold'}}         
                        >
                            Monto exento
                        </Typography>
                    </Itemd>
                </Grid>
                <Grid xs={1.8}>
                    <Itemd component="div" >
                        <Typography color={color} 
                                align={'center'}
                                fontSize={Tletra-1} noWrap
                                sx={{ fontWeight:'bold'}}          
                        >
                            Base imponible
                        </Typography>
                    </Itemd>
                </Grid>
                <Grid xs={1}>
                    <Itemd component="div" >
                        <Typography color={color} 
                                align={'center'}
                                fontSize={Tletra-1} noWrap
                                sx={{ fontWeight:'bold'}}          
                        >
                            Alícuota
                        </Typography>
                    </Itemd>
                </Grid>
                <Grid xs={1.5}>
                    <Itemd component="div" >
                        <Typography color={color} 
                                align={'center'}
                                fontSize={Tletra-1} noWrap 
                                sx={{ fontWeight:'bold'}}         
                        >
                            Monto IVA
                        </Typography>
                    </Itemd>
                </Grid>
                <Grid xs={1.3}>
                    <Itemd component="div" >
                        <Typography color={color} 
                                align={'center'}
                                fontSize={Tletra-1} noWrap  
                        >
                            {moment(datos.fechaf).format('DD/MM/YYYY')}
                        </Typography>
                    </Itemd>
                </Grid>
                <Grid xs={1.5}>
                    <Itemd component="div" >
                        <Typography color={color} 
                                align={'center'}
                                fontSize={Tletra-1} noWrap  
                        >
                            {datos.numerof}
                        </Typography>
                    </Itemd>
                </Grid>
                <Grid xs={1.8}>
                    <Itemd component="div" >
                        <Typography color={color} 
                                align={'center'}
                                fontSize={Tletra-1} noWrap       
                        >
                            {datos.numerofc}
                        </Typography>
                    </Itemd>
                </Grid>
                <Grid xs={1.5}>
                    <Itemd component="div" >
                        <Typography color={color} 
                                align={'right'}
                                fontSize={Tletra-1} noWrap  
                        >
                            {Moneda(Number(datos.montoft),'Bs', false)}
                        </Typography>
                    </Itemd>
                </Grid>
                <Grid xs={1.6}>
                    <Itemd component="div" >
                        <Typography color={color} 
                                align={'right'}
                                fontSize={Tletra-1} noWrap 
                        >
                            {Moneda(Number(datos.montofe ? datos.montofe : '0.00'),'Bs', false)}
                        </Typography>
                    </Itemd>
                </Grid>
                <Grid xs={1.8}>
                    <Itemd component="div" >
                        <Typography color={color} 
                                align={'right'}
                                fontSize={Tletra-1} noWrap
                        >
                            {Moneda(Number(datos.baseimponible),'Bs', false)}
                        </Typography>
                    </Itemd>
                </Grid>
                <Grid xs={1}>
                    <Itemd component="div" >
                        <Typography color={color} 
                                align={'center'}
                                fontSize={Tletra-1} noWrap
                        >
                            {datos.alicuota}%
                        </Typography>
                    </Itemd>
                </Grid>
                <Grid xs={1.5}>
                    <Itemd component="div" >
                        <Typography color={color} 
                                align={'right'}
                                fontSize={Tletra-1} noWrap         
                        >
                            {Moneda(Number(datos.montoi),'Bs', false)}
                        </Typography>
                    </Itemd>
                </Grid>
            </Grid>
            <Grid xs={3} container>
                <Grid xs={12}>
                    <Itemd component="div" >
                        <Typography color={color} 
                                align={'center'}
                                fontSize={Tletra-1} noWrap          
                        >
                            RETENCIÓN
                        </Typography>
                    </Itemd>
                </Grid>
                <Grid xs={5}>
                    <Itemd component="div" >
                        <Typography color={color} 
                                align={'center'}
                                fontSize={Tletra-1} noWrap 
                                sx={{ fontWeight:'bold'}}         
                        >
                            Porcentaje
                        </Typography>
                    </Itemd>
                </Grid>
                <Grid xs={7}>
                    <Itemd component="div" >
                        <Typography color={color} 
                                align={'center'}
                                fontSize={Tletra-1} noWrap 
                                sx={{ fontWeight:'bold'}}         
                        >
                            Monto
                        </Typography>
                    </Itemd>
                </Grid>
                <Grid xs={5}>
                    <Itemd component="div" >
                        <Typography color={color} 
                                align={'center'}
                                fontSize={Tletra-1} noWrap 
                        >
                            {datos.porcentaje}%
                        </Typography>
                    </Itemd>
                </Grid>
                <Grid xs={7}>
                    <Itemd component="div" >
                        <Typography color={color} 
                                align={'right'}
                                fontSize={Tletra-1} noWrap 
                        >
                            {Moneda(Number(datos.monto),'Bs', false)}
                        </Typography>
                    </Itemd>
                </Grid>
            </Grid>
            <Grid xs={12}>
                <Box sx={{height:10}}/>
            </Grid>
            <Grid xs={2}>
                <Box component={'div'} sx={{ml:2}}>
                    <img alt='logo' src={logof} height={78}/>
                </Box>
            </Grid>
            <Grid xs={10} container spacing={0} sx={{  justifyContent: "center",
    alignItems: "center",}} >
                <Grid xs={7}/>
                <Grid xs={3}>
                    <Itemd component="div" >
                        <Typography color={color} 
                                align={'right'}
                                fontSize={Tletra-1} noWrap 
                                sx={{ fontWeight:'bold'}}         
                        >
                            TOTAL MONTO RETENIDO:
                        </Typography>
                    </Itemd>
                </Grid>
                <Grid xs={2}>
                    <Itemd component="div" >
                        <Typography color={color} 
                                align={'right'}
                                fontSize={Tletra-1} noWrap 
                        >
                            {Moneda(Number(datos.montoretenido ),'Bs', false)}
                        </Typography>
                    </Itemd>
                </Grid>
            
                <Grid xs={7}/>
                <Grid xs={3}>
                    <Itemd component="div" >
                        <Typography color={color} 
                                align={'right'}
                                fontSize={Tletra-1} noWrap 
                                sx={{ fontWeight:'bold'}}         
                        >
                            NETO A PAGAR:
                        </Typography>
                    </Itemd>
                </Grid>
                <Grid xs={2}>
                    <Itemd component="div" >
                        <Typography color={color} 
                                align={'right'}
                                fontSize={Tletra-1} noWrap 
                        >
                            {Moneda(Number(datos.netoapagar),'Bs', false)}
                        </Typography>
                    </Itemd>
                </Grid>
            </Grid>
        </Grid>
        </Box>
    );
}
